import { IShimmerProps, IStyle, mergeStyleSets, Shimmer, ShimmerElementType, Stack } from "@fluentui/react";
import React, { useRef } from "react";
import DisplayAPIsException from "../../BasicComponents/DisplayAPIsExceptionAlert";
import { IPartnerInfoIdentityProps } from "../../interfaces/PartnerView.interfaces";
import { PartnerInfoIdentityDetails } from "./PartnerInfoIdentityDetails";
import { bgColor, commonColor, customerInfoDetailsColor, shimmerColor } from "../../constants/PartnerView.constants";

const customerInfoIdentityFirstLetterShimmer = {
  style: { marginTop: 10, width: 60 },
  shimmerElements: [{ type: ShimmerElementType.gap, height: 50 }]
};

const styles = mergeStyleSets({
  customerInfoIdentity: {
    marginLeft: 10,
    fontSize: 14,
    paddingBottom: 10,
    color: customerInfoDetailsColor
  } as IStyle,
  customerInfoDetails: {
    display: "flex",
    color: customerInfoDetailsColor
  } as IStyle,
  customerInfoIdentityInitialLetterStack: {
    fontSize: 44,
    color: commonColor,
    paddingTop: 8,
    border: "0.7px",
    borderRadius: 10
  } as IStyle,
  customerInfoIdentityInitialLetterStackLabel: {
    background: bgColor
  } as IStyle
});


export const PartnerInfoIdentity = (props: IPartnerInfoIdentityProps) => {
  const custInfoIdentityRef = useRef<any>();
  const style = {
    display: props.error ? "block" : "flex"
  } as React.CSSProperties;

  return (
    <div ref={custInfoIdentityRef}>
      <Stack horizontal style={style}>
        {(!props.error && (
          <>
            <LoadShimmer shimmerProps={customerInfoIdentityFirstLetterShimmer} loading={props.loading} />
            <PartnerInfoIdentityInitialLetter {...props} />
            <PartnerInfoIdentityDetails
              loading={props.loading}
              name={props.name}
              partnerOneID={props.partnerOneID}
              mpnId={props.mpnId}
              mpnName={props.mpnName}
            />
          </>
        )) || <DisplayAPIsException height={custInfoIdentityRef.current?.offsetHeight} />}
      </Stack>
    </div>
  );
};

const PartnerInfoIdentityInitialLetter = (props: { name: string; loading: boolean; }) => {

  return !props.loading ? (
    <Stack className={styles.customerInfoIdentityInitialLetterStack}>
      <label
        className={styles.customerInfoIdentityInitialLetterStackLabel}
        style={{ padding: "0 6px" }}
      >
        <b>
            <>
              {props.name?.charAt(0)}
              <PartnerNameInitial name={props.name} />
            </>
        </b>
      </label>
    </Stack>
  ) : null;
};

const PartnerNameInitial = ({ name }: { name?: string }) => {
  const _name = name ?? "";
  const idx = _name.lastIndexOf(" ");
  const initial: string = _name.charAt(idx > 0 ? idx + 1 : idx);
  return initial.match(/^[a-z]/i) ? initial : "";
};

const LoadShimmer = (props: { shimmerProps: IShimmerProps; loading: boolean }) => {
  return props.loading ? <Shimmer {...props.shimmerProps} shimmerColors={{ shimmer: shimmerColor }}></Shimmer> : null;
};